/*
* 首页路由
* */
export default [
    {
        path : '/home',
        name : 'home',
        component : resolve => {
            require(['components/Home/index.vue'], resolve);
        },
        meta : {
            title : '首页'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/routers/home.js